/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgIHN0eWxlPSJ0cmFuc2Zvcm06cm90YXRlKDE4MGRlZykiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNzEgMEw2LjcxIDZMMC43MSAwTDAgMC43MUw2LjcxIDcuNDJMMTMuNDIgMC43MUwxMi43MSAwWiIgZmlsbD0iIzdGN0Y3RiIvPjwvc3ZnPg==";